import { featureState, isFeatureOpen, type FeatureState, type ProductFeature, type ProductFeatureMap } from '@tfa/shared'
import { useAuth } from './useAuth'

/**
 * Доступ к функциям по тарифу (три тарифа, этап 1).
 *
 * Сервер отдаёт в /auth/me карту `access` — действующую матрицу тарифа с
 * переопределениями из админки. Пока карты нет (старый ответ, куратор в режиме
 * просмотра) — дефолты из @tfa/shared, как раньше. Три состояния: 'open',
 * 'locked' (замок поверх экрана), 'gray' (элемент виден, но неактивен), 'off'.
 */
export function useFeatureAccess() {
  const { user } = useAuth()
  const u = user as { product?: string | null; access?: Partial<ProductFeatureMap> | null } | undefined
  const product = u?.product ?? null
  const access = u?.access ?? null
  return {
    product,
    access,
    state: (feature: ProductFeature): FeatureState => featureState(product, feature, access),
    has: (feature: ProductFeature): boolean => isFeatureOpen(product, feature, access),
  }
}
